export const genderData = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

export const patientMovingFromData = [
  { value: "Within Country", label: "Within Country" },
  { value: "Outside Country", label: "Outside Country" },
];

export const arrivalWithinData = [
  { value: "Less than 3 Days", label: "Less than 3 Days" },
  { value: "Less than 7 Days", label: "Less than 7 Days" },
  { value: "Less than 15 Days", label: "Less than 15 Days" },
  { value: "Less than 30 Days", label: "Less than 30 Days" },
  { value: "More than 30 Days", label: "More than 30 Days" },
];

export const stateData = [
  {
    value: "Andaman and Nicobar Islands",
    label: "Andaman and Nicobar Islands",
  },
  { value: "Andhra Pradesh", label: "Andhra Pradesh" },
  { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
  { value: "Assam", label: "Assam" },
  { value: "Bihar", label: "Bihar" },
  { value: "Chandigarh", label: "Chandigarh" },
  { value: "Chhattisgarh", label: "Chhattisgarh" },
  {
    value: "Dadra and Nagar Haveli and Daman and Diu",
    label: "Dadra and Nagar Haveli and Daman and Diu",
  },
  { value: "Delhi", label: "Delhi" },
  { value: "Goa", label: "Goa" },
  { value: "Gujarat", label: "Gujarat" },
  { value: "Haryana", label: "Haryana" },
  { value: "Himachal Pradesh", label: "Himachal Pradesh" },
  { value: "Jammu and Kashmir", label: "Jammu and Kashmir" },
  { value: "Jharkhand", label: "Jharkhand" },
  { value: "Karnataka", label: "Karnataka" },
  { value: "Kerala", label: "Kerala" },
  { value: "Ladakh", label: "Ladakh" },
  { value: "Lakshadweep", label: "Lakshadweep" },
  { value: "Madhya Pradesh", label: "Madhya Pradesh" },
  { value: "Maharashtra", label: "Maharashtra" },
  { value: "Manipur", label: "Manipur" },
  { value: "Meghalaya", label: "Meghalaya" },
  { value: "Mizoram", label: "Mizoram" },
  { value: "Nagaland", label: "Nagaland" },
  { value: "Odisha", label: "Odisha" },
  { value: "Other Countries", label: "Other Countries" },
  { value: "Other Territory", label: "Other Territory" },
  { value: "Puducherry", label: "Puducherry" },
  { value: "Punjab", label: "Punjab" },
  { value: "Rajasthan", label: "Rajasthan" },
  { value: "Sikkim", label: "Sikkim" },
  { value: "Tamil Nadu", label: "Tamil Nadu" },
  { value: "Telangana", label: "Telangana" },
  { value: "Tripura", label: "Tripura" },
  { value: "Uttar Pradesh", label: "Uttar Pradesh" },
  { value: "Uttarakhand", label: "Uttarakhand" },
  { value: "West Bengal", label: "West Bengal" },
];

export const Days = [
  { value: "today", label: "Today" },
  { value: "last_week", label: "Last 7 Days" },
  { value: "last_month", label: "Last 30 Days" },
  { value: "custom", label: "Custom" },
];

export const companyTypes = [
  { value: "Company", label: "Company" },
  { value: "Individual", label: "Individual" },
];

export const roleOptions = [
  { value: "doctor", label: "Doctor" },
  { value: "ips", label: "IPS" },
];

export const FlightTicketFreezeFields = {
  patientName: false,
  patientPassport: false,
  patientPassportNumber: false,
  patientDob: false,
  patientCountryOfRes: false,
  patientNationality: false,
  attendantName: false,
  attendantPassportNumber: false,
  attendantPassport: false,
};

export const MedicalOpinionFreezeFields = {
  name: false,
  passport: false,
  passportNumber: false,
  dob: false,
  countryOfResidence: false,
  nationality: false,
  gender: false,
};

export const reportsFileExtensions = [
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".doc",
  ".docx",
  ".gif",
  ".dcm",
  ".bmp",
  ".mp4",
  ".avi",
  ".mpeg",
  ".wmv",
  ".mov",
  ".flv",
  ".m2v",
  ".ogv",
  ".xvid",
  ".divx",
  ".hevc",
  ".h265",
  ".vob",
  ".mkv",
  ".webm",
  ".3gp",
  ".ts",
  ".flc",
  ".asf",
  ".dv",
  ".swf",
  ".m2ts",
  ".mxf",
  ".f4v",
  ".rmvb",
  ".h263",
  ".m4v",
  ".mpg4",
  ".m3u8",
  ".3g2",
  ".dat",
  ".mk3d",
  ".ogm",
];
